import { all, fork } from 'redux-saga/effects';

import watchFooterRequest from './footerRequest';
import watchMenuCategoryRequest from './menuCategoryRequest';
import watchResfreshServices from './refreshServices';
import watchSendCampaignRequest from './sendCampaignRequest';
import watchSeoRequest from './seoRequest';

function* appSagas() {
  yield all([
    fork(watchResfreshServices),
    fork(watchFooterRequest),
    fork(watchMenuCategoryRequest),
    fork(watchSeoRequest),
    fork(watchSendCampaignRequest),
  ]);
}

export default appSagas;
